module.exports = __webpack_public_path__ + "static/maggie-941e8dbb7d9a5fb2b921224bf7d44d7a.jpg";